import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Template } from '../models/template';
import { ResourcefulService } from './resourcefulService';
import { baseUrl } from './api-config';
import { FileInput } from 'ngx-material-file-input';



@Injectable({
    providedIn: 'root'
})
export class TemplateService extends ResourcefulService<Template>{
    constructor(private httpClient: HttpClient) {
        super(httpClient, Template);
    }

    public create(model): Promise<any> {
        this.count++;
        return this._httpClient.post(
            `${this.baseUrl}/${this.modelClass.apiUrl}`,
            this.toFormData(model),
        ).toPromise();
    }

    public edit(model: Template): Promise<any> {
        const formData = this.toFormData({ ...model, _method: 'PATCH' });
        return this._httpClient.post(
            `${this.baseUrl}/${this.modelClass.apiUrl}/${model.id}`,
            formData,
        ).toPromise();
    }

    protected toFormData(data: Record<string, any>) {
        let formData = new FormData();
        for (let [key, val] of Object.entries(data)) {
            if (val) {
                if (key == 'file') {
                    val = val as FileInput;
                    formData.append(key, val.files[0], val.files[0].name);
                }
                else if (typeof val == 'string')
                    formData.append(key, val);
                else formData.append(key, JSON.stringify(val));
            }
        }
        return formData;
    }


    open(file: Template, desiresPdfVersion: boolean = false) {

        //get the requested file, add "?pdf=1" if user requests pdf version.
        return this.httpClient.get(`${baseUrl}/templates/${file.id}${desiresPdfVersion ? '?pdf=1' : ''}`, {
            headers: {
                'responseType': 'blob',
                'Content-Type': 'application/json',
                'Accept': 'text/plain, */*',
                'Cache-Control': 'no-cache',
            },
            responseType: 'blob'
        });
    }


    convertToPdf(file: Template): Promise<any> {
        return this.httpClient.get(`${baseUrl}/templates/${file.id}/convertToPdf`).toPromise();
    }

    findByNameLike(namePattern: string): Promise<any> {
        return this.httpClient.get<any>(`${baseUrl}/templates/default-data/${encodeURIComponent(namePattern)}`)
            .toPromise();
    }
}
